import Table from "src/components/Common/UI/DndTable/Table";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import Modal from "src/components/Common/UI/Modal/Modal";
import EditLine from "../../LinesAndNodesConfiguration/Lines/EditLine";
import TableActionButtons from "src/components/Common/UI/DndTable/ActionButtons/TableActionButtons";
import { useDataLinesTable } from "./hooks/useDataLinesTable";

const DataLinesTable = ({unitID}: DataLinesTableProps) => {

  const {
    data,
    columns,
    loadingDone,
    setSelectedRowsOfTable,
    selectedRowsOfTable,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
    modalEvent
  } = useDataLinesTable({unitID: unitID});
  
  const ActionButtons: React.FC = () => (
    <TableActionButtons event={actionEvent} canEdit={selectedRowsOfTable.length > 0} canDelete={false} />
  );

  return (
    <>
      <Table
         columns={columns}
         data={data}
         defaultOrderByKeyFilter={"id"}
         showNumberOfRows={false}
         rowSelection={true}
         setRowSelection={setSelectedRowsOfTable}
         multipleRowSelection={false}
         actionRowId={"id"}
         debugMode={false}
         noDataFoundTitle="No Lines yet"
         isChangeOrderOrVisibilityEnable={false}
         ButtonsAreaLeft={ActionButtons}
      />

      <Modal
        isOpen={!!modalEvent.action}
        closeFilterModal={closeActionModal}
        title={getModalTitleByAction()}  
        size="xl"
        >
          {modalEvent.action === "edit" && <EditLine handleCloseModal={closeActionModal} lineId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
      </Modal>

      {!loadingDone && <LoadingSpinner />}
    </>
  )
}

export default DataLinesTable;

interface DataLinesTableProps {
  unitID: number;
}